type Props = {
    width?:number;
    height?:number;
    fill?:string;
}

const AnalysticsIcon = ({
    width =20,
    height=20,
    fill="none"
}: Props) =>{
    return (
  <svg width={width} height={height} viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
<path d="M13.3334 5.83337H18.3334V10.8334" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M18.3333 5.83337L11.25 12.9167L7.08329 8.75004L1.66663 14.1667" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>





    )
}

export default AnalysticsIcon;